import { createCustomersService } from "api-client";

/** Relative to `VITE_API_BASE_URL` (e.g. `.../api`). Override `VITE_CUSTOMERS_API_PATH` if the list URL differs (default `customers/list`). */
const path =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "";

export const customersService = createCustomersService(path);
